define('lib/markdown',['require','exports','module','marked'],function(require,exports,module){
  "use strict";
  var marked = require("marked"),
    renderer = new marked.Renderer();

  // Avoiding to enclose text into <p></p>
  renderer.paragraph = function(text, level) {
    return text;
  };

  // Add target=_blank to links
  renderer.link = function(href, title, text) {
    var a = marked.Renderer.prototype.link.call(renderer, href, title, text);
    return a.replace(/a href=/g, "a target=\"_blank\" href=");
  };

  module.exports = function (text) {
    return marked(text, { renderer: renderer});
  };

});

